import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { VxIconComponent } from '../icon/icon.component';
import { breadcrumbItemVariants } from './breadcrumb.variants';

/**
 * One crumb inside `<vx-breadcrumb>`. Content is fully projected — a plain
 * label, or any leading visual (icon, status ring, avatar) next to it:
 *
 *   <vx-breadcrumb-item link="/incidents">
 *     <vx-icon name="fire" />
 *     Incidents
 *   </vx-breadcrumb-item>
 *
 * With `link` set the crumb renders as a router link; without it the anchor
 * has no href (RouterLink disables itself on null) and is marked
 * `aria-current="page"` — the current-page crumb per the APG pattern.
 *
 * The caret separator lives inside each item and hides itself on the first
 * one (`group-first:`), so consumers never manage separators.
 */
@Component({
  selector: 'vx-breadcrumb-item',
  templateUrl: './breadcrumb-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, VxIconComponent],
  host: { class: 'group flex items-center gap-4', role: 'listitem' },
})
export class VxBreadcrumbItemComponent {
  /** Router target; omit on the current-page (last) crumb. */
  readonly link = input<string | readonly unknown[] | null>(null);

  protected readonly classes = computed(() =>
    breadcrumbItemVariants({ interactive: this.link() !== null }),
  );
}
